import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from 'moment';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

const convertNumberService = new ConvertNumService();

export default {
    name: "classSession",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            sessionData : {},
            lastPage: "",
            pg_status: false,
            currentPageMn: "",
            currentPage: 1,
            number:"",
            perPage:10,
            keyword:""
        };
    },

    computed: {
        ...mapGetters(["userType"]),
        startNumber() {
          const page = Number(this.currentPage) || 1;
          const perPage = Number(this.perPage) || 10;
          return (page - 1) * perPage + 1;
        }
    },

    methods: {
        search(page = 1) {
          const request = {
            keyword: this.keyword,
            class_id: this.$route.params.id,
            page: page
          }
          if (!this.keyword || this.keyword.trim() === "") {
            this.getClassSession()
            return
          }
          axios.get(`class/session/filter`, { params: request })
          .then((res) => {
            this.pg_status = true;
            this.sessionData = res.data;
            this.sessionData.totalPage = convertNumberService.convertEng2Mm(this.sessionData.total);
            this.lastPage = convertNumberService.convertEng2Mm(this.sessionData.last_page);
            this.currentPageMn = convertNumberService.convertEng2Mm(this.sessionData.current_page);
            this.currentPage = res.data.current_page;
            this.perPage = res.data.per_page;
          })
          .catch((err) => {
            if (err.response == 401) {
              this.$store.commit('logout');
              window.location.replace('/');
            }
            console.log("Student Search API Error", err);
            })
        },
        getClassSession(page = 1) {
          axios.get(`class/session/${this.$route.params.id}?page=${page}`)
          .then((res) => {
            this.sessionData = res.data;
            this.sessionData.totalPage = convertNumberService.convertEng2Mm(this.sessionData.total);
            this.lastPage = convertNumberService.convertEng2Mm(this.sessionData.last_page);
            this.currentPageMn = convertNumberService.convertEng2Mm(this.sessionData.current_page);
            this.currentPage = res.data.current_page;
            this.perPage = res.data.per_page;
          }).catch((error) => {
            if (error.response.status == 404) {
              this.$router.push({ name: 'notFound'
              });
            }
            console.log(error)
          })
        },
        customFormatter(time) {
          return moment(time, "HH:mm:ss").format('HH:mm');
        },
        deleteSession(id) {
          if(!confirm("Are you sure you want to delete this session?")) return;
          axios.delete(`class/session/${id}`)
          .then(() => {
            this.$notification.success("Class Session deleted successfully", { timer: 3, position: "bottomCenter"
            });
            let newPage = this.currentPage;
            const remainingItems = this.sessionData.total - 1;
            const itemsPerPage = 10;
            const maxPage = Math.ceil(remainingItems / itemsPerPage);

            if (newPage > maxPage) {
              newPage = maxPage > 0 ? maxPage : 1;
            }
            this.getClassSession(newPage);
          })
          .catch(() => {
            this.$notification.error("Failed to delete session", {
              timer: 3,
              position: "bottomCenter"
            });
          })
        }
    },

    mounted() {
      this.getClassSession()
    }
};
